import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-retraite-complementaire-entreprise',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-retraite-complementaire-entreprise.component.html',
  styleUrls: ['./assurance-retraite-complementaire-entreprise.component.scss']
})
export class AssuranceRetraiteComplementaireEntrepriseComponent {
  title = 'Assurance Retraite Complémentaire Entreprise';
  subtitle = '';
  heroImage = 'assets/static_pages_images/rcpro.jpg';

  constructor(private router: Router) {}
  
  breadcrumbs = [
    { label: 'Entreprises', path: undefined },
    { label: 'Retraite Complémentaire', path: undefined }
  ];

  prevPage = {
    title: 'Retraite Complémentaire Pro', link: '/assurance-retraite-complementaire-pro'
  };

  nextPage = {
    title: 'Assurance Voyage Professionnel', link: '/assurance-voyage-professionnel'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/logos/generali.png' },
    { name: 'ALPTIS', logo: 'assets/logos/alptis.png' },
    { name: 'SWISSLIFE', logo: 'assets/logos/SWISSLIFE.PNG' },
    { name: 'MALAKOFF HUMANIS', logo: 'assets/logos/malakoff.png' }
  ];

  navigateToContact(): void {
    this.router.navigate(['/'], { fragment: 'contact' });
  }
}
